import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private readonly THEME_KEY = "prime-theme";
  isDarkMode = signal<boolean>(false);

  constructor() {
    // Charger le thème depuis localStorage
    const savedTheme = localStorage.getItem(this.THEME_KEY);
    if (savedTheme) {
      this.isDarkMode.set(savedTheme === "dark");
    } else {
      // Forcer le thème clair par défaut
      this.isDarkMode.set(false);
    }
    this.applyTheme();
  }

  toggleTheme(): void {
    this.isDarkMode.update((current) => !current);
    this.saveTheme();
    this.applyTheme();
  }

  private saveTheme(): void {
    localStorage.setItem(this.THEME_KEY, this.isDarkMode() ? "dark" : "light");
  }

  private applyTheme(): void {
    const root = document.documentElement;
    if (this.isDarkMode()) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }
}
